module.exports = __webpack_public_path__ + "static/media/tommySleeve3.86df9b12.svg";